import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=fbe04fa2&scoped=true&"
import script from "./autocomplete.vue?vue&type=script&lang=ts&"
export * from "./autocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./autocomplete.vue?vue&type=style&index=0&id=fbe04fa2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe04fa2",
  null
  
)

export default component.exports